
import { Controller } from 'stimulus'

export default class PageController extends Controller {
  reload() {
    SecuricyApp.window.location.reload()
  }
}
